import { useAppSelector } from "../app/hooks";
import { isToken } from "../services/slices/profile";

const isAuthenticated = () => {
    let token: string | null = useAppSelector(isToken)

    // return true;

    return token
}


export default isAuthenticated;

